"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const brand = "#A6192E"; // red
const headerBackgroundColor = "#FFFFFF";
const headerTextColor = "#A6192E";
const appAccentColor = brand;
const mainInfoPortrait = headerTextColor;
const mainInfoLandscape = headerTextColor;
const style = "normal";
const fontFamily = "";
const colorAppBar = "#FFFFFF";
const colorOnAppBar = "#A6192E";
const colorPrimary = "#A6192E";
const colorPrimaryDarker = "#7c1322";
const colorPrimaryLighter = "#f7c8cf";
const colorOnPrimary = "#FFFFFF";
const colorSecondary = "#A6192E";
const colorOnSecondary = "#FFFFFF";
const colorTiles = ["#A6192E", "#A6192E", "#A6192E"];
exports.default = {
    headerTextColor,
    appAccentColor,
    mainInfoLandscape,
    mainInfoPortrait,
    brand,
    headerBackgroundColor,
    fontFamily,
    style,
    colorAppBar,
    colorOnAppBar,
    colorPrimary,
    colorPrimaryDarker,
    colorPrimaryLighter,
    colorOnPrimary,
    colorSecondary,
    colorOnSecondary,
    colorTiles,
};
